export default __webpack_public_path__ + "static/media/new-stream.fc511cb0.svg";